enum Acao {
  CONSULTAR = 'CONSULTAR',
  ATUALIZAR = 'ATUALIZAR',
  DELETAR = 'DELETAR',
  INSERIR = 'INSERIR',
}

function montarRoles(funcao: string, acao: Acao) {
  return [
    'ROLE_ADMIN',
    `ROLE_${funcao.toUpperCase()}_${acao}`,
    `ROLE_${funcao.toUpperCase()}_ACESSO_TOTAL`,
  ];
}

export const Roles = {
  Pessoa: {
    Consultar: montarRoles('Pessoa', Acao.CONSULTAR),
    Atualizar: montarRoles('Pessoa', Acao.ATUALIZAR),
    Inserir: montarRoles('Pessoa', Acao.INSERIR),
    Deletar: montarRoles('Pessoa', Acao.DELETAR),
  },
  Colaborador: {
    Consultar: montarRoles('COLABORADOR', Acao.CONSULTAR),
    Atualizar: montarRoles('COLABORADOR', Acao.ATUALIZAR),
    Inserir: montarRoles('COLABORADOR', Acao.INSERIR),
    Deletar: montarRoles('COLABORADOR', Acao.DELETAR),
  },
  Transportadora: {
    Consultar: montarRoles('TRANSPORTADORA', Acao.CONSULTAR),
    Atualizar: montarRoles('TRANSPORTADORA', Acao.ATUALIZAR),
    Inserir: montarRoles('TRANSPORTADORA', Acao.INSERIR),
    Deletar: montarRoles('TRANSPORTADORA', Acao.DELETAR),
  },
  AtividadeForCli: {
    Consultar: montarRoles('ATIVIDADE_FOR_CLIENTE', Acao.CONSULTAR),
    Atualizar: montarRoles('ATIVIDADE_FOR_CLIENTE', Acao.ATUALIZAR),
    Inserir: montarRoles('ATIVIDADE_FOR_CLIENTE', Acao.INSERIR),
    Deletar: montarRoles('ATIVIDADE_FOR_CLIENTE', Acao.DELETAR),
  },
  SituacaoForCli: {
    Consultar: montarRoles('SITUACAO_FOR_CLIENTE', Acao.CONSULTAR),
    Atualizar: montarRoles('SITUACAO_FOR_CLIENTE', Acao.ATUALIZAR),
    Inserir: montarRoles('SITUACAO_FOR_CLIENTE', Acao.INSERIR),
    Deletar: montarRoles('SITUACAO_FOR_CLIENTE', Acao.DELETAR),
  },
  Cliente: {
    Consultar: montarRoles('CLIENTE', Acao.CONSULTAR),
    Atualizar: montarRoles('CLIENTE', Acao.ATUALIZAR),
    Inserir: montarRoles('CLIENTE', Acao.INSERIR),
    Deletar: montarRoles('CLIENTE', Acao.DELETAR),
  },
  Fornecedor: {
    Consultar: montarRoles('Fornecedor', Acao.CONSULTAR),
    Atualizar: montarRoles('Fornecedor', Acao.ATUALIZAR),
    Inserir: montarRoles('Fornecedor', Acao.INSERIR),
    Deletar: montarRoles('Fornecedor', Acao.DELETAR),
  },
  Produto: {
    Consultar: montarRoles('Produto', Acao.CONSULTAR),
    Atualizar: montarRoles('Produto', Acao.ATUALIZAR),
    Inserir: montarRoles('Produto', Acao.INSERIR),
    Deletar: montarRoles('Produto', Acao.DELETAR),
  },
  Papel: {
    Consultar: montarRoles('Papel', Acao.CONSULTAR),
    Atualizar: montarRoles('Papel', Acao.ATUALIZAR),
    Inserir: montarRoles('Papel', Acao.INSERIR),
    Deletar: montarRoles('Papel', Acao.DELETAR),
  },
  CondicaoPagamento: {
    Consultar: montarRoles('CONDICOES_PAGAMENTO', Acao.CONSULTAR),
    Atualizar: montarRoles('CONDICOES_PAGAMENTO', Acao.ATUALIZAR),
    Inserir: montarRoles('CONDICOES_PAGAMENTO', Acao.INSERIR),
    Deletar: montarRoles('CONDICOES_PAGAMENTO', Acao.DELETAR),
  },
  TipoPagamento: {
    Consultar: montarRoles('TIPO_PAGAMENTO', Acao.CONSULTAR),
    Atualizar: montarRoles('TIPO_PAGAMENTO', Acao.ATUALIZAR),
    Inserir: montarRoles('TIPO_PAGAMENTO', Acao.INSERIR),
    Deletar: montarRoles('TIPO_PAGAMENTO', Acao.DELETAR),
  },
  TipoRecebimento: {
    Consultar: montarRoles('TIPO_RECEBIMENTO', Acao.CONSULTAR),
    Atualizar: montarRoles('TIPO_RECEBIMENTO', Acao.ATUALIZAR),
    Inserir: montarRoles('TIPO_RECEBIMENTO', Acao.INSERIR),
    Deletar: montarRoles('TIPO_RECEBIMENTO', Acao.DELETAR),
  },
  PlanoNaturezaFinanceira: {
    Consultar: montarRoles('PLANO_NATUREZA_FINANCEIRA', Acao.CONSULTAR),
    Atualizar: montarRoles('PLANO_NATUREZA_FINANCEIRA', Acao.ATUALIZAR),
    Inserir: montarRoles('PLANO_NATUREZA_FINANCEIRA', Acao.INSERIR),
    Deletar: montarRoles('PLANO_NATUREZA_FINANCEIRA', Acao.DELETAR),
  },
  NaturezaFinanceira: {
    Consultar: montarRoles('NATUREZA_FINANCEIRA', Acao.CONSULTAR),
    Atualizar: montarRoles('NATUREZA_FINANCEIRA', Acao.ATUALIZAR),
    Inserir: montarRoles('NATUREZA_FINANCEIRA', Acao.INSERIR),
    Deletar: montarRoles('NATUREZA_FINANCEIRA', Acao.DELETAR),
  },
  Equipamento: {
    Consultar: montarRoles('OS_EQUIPAMENTO', Acao.CONSULTAR),
    Atualizar: montarRoles('OS_EQUIPAMENTO', Acao.ATUALIZAR),
    Inserir: montarRoles('OS_EQUIPAMENTO', Acao.INSERIR),
    Deletar: montarRoles('OS_EQUIPAMENTO', Acao.DELETAR),
  },
  Financeiro: {
    LancamentoPagar: {
      Consultar: montarRoles('LANCAMENTO_PAGAR', Acao.CONSULTAR),
      Atualizar: montarRoles('LANCAMENTO_PAGAR', Acao.ATUALIZAR),
      Inserir: montarRoles('LANCAMENTO_PAGAR', Acao.INSERIR),
      Deletar: montarRoles('LANCAMENTO_PAGAR', Acao.DELETAR),
    },
    LancamentoReceber: {
      Consultar: montarRoles('LANCAMENTO_RECEBER', Acao.CONSULTAR),
      Atualizar: montarRoles('LANCAMENTO_RECEBER', Acao.ATUALIZAR),
      Inserir: montarRoles('LANCAMENTO_RECEBER', Acao.INSERIR),
      Deletar: montarRoles('LANCAMENTO_RECEBER', Acao.DELETAR),
    },
    Recebimento: {
      Consultar: montarRoles('RECEBIMENTO', Acao.CONSULTAR),
      Atualizar: montarRoles('RECEBIMENTO', Acao.ATUALIZAR),
      Inserir: montarRoles('RECEBIMENTO', Acao.INSERIR),
      Deletar: montarRoles('RECEBIMENTO', Acao.DELETAR),
    },
    Pagamento: {
      Consultar: montarRoles('PARCELA_PAGAMENTO', Acao.CONSULTAR),
      Atualizar: montarRoles('PARCELA_PAGAMENTO', Acao.ATUALIZAR),
      Inserir: montarRoles('PARCELA_PAGAMENTO', Acao.INSERIR),
      Deletar: montarRoles('PARCELA_PAGAMENTO', Acao.DELETAR),
    },
    FluxoCaixa: {
      Consultar: montarRoles('FLUXO_CAIXA', Acao.CONSULTAR),
    },
    CreditoCliente: {
      Consultar: montarRoles('CREDITO_CLIENTE', Acao.CONSULTAR),
      Atualizar: montarRoles('CREDITO_CLIENTE', Acao.ATUALIZAR),
      Inserir: montarRoles('CREDITO_CLIENTE', Acao.INSERIR),
      Deletar: montarRoles('CREDITO_CLIENTE', Acao.DELETAR),
    },
  },
  Comercial: {
    Orcamento: {
      Consultar: montarRoles('Orcamento', Acao.CONSULTAR),
      Atualizar: montarRoles('Orcamento', Acao.ATUALIZAR),
      Inserir: montarRoles('Orcamento', Acao.INSERIR),
      Deletar: montarRoles('Orcamento', Acao.DELETAR),
    },
    Pedido: {
      Consultar: montarRoles('Pedido', Acao.CONSULTAR),
      Atualizar: montarRoles('Pedido', Acao.ATUALIZAR),
      Inserir: montarRoles('Pedido', Acao.INSERIR),
      Deletar: montarRoles('Pedido', Acao.DELETAR),
    },
    PreVenda: {
      Consultar: montarRoles('venda', Acao.CONSULTAR),
      Atualizar: montarRoles('venda', Acao.ATUALIZAR),
      Inserir: montarRoles('venda', Acao.INSERIR),
      Deletar: montarRoles('venda', Acao.DELETAR),
    },
    Pdv: {
      Consultar: montarRoles('FRENTE_CAIXA', Acao.CONSULTAR),
      Atualizar: montarRoles('FRENTE_CAIXA', Acao.ATUALIZAR),
      Inserir: montarRoles('FRENTE_CAIXA', Acao.INSERIR),
      Deletar: montarRoles('FRENTE_CAIXA', Acao.DELETAR),
    },
    MovimentoCaixa: {
      Consultar: montarRoles('PDV_MOVIMENTO', Acao.CONSULTAR),
      Atualizar: montarRoles('PDV_MOVIMENTO', Acao.ATUALIZAR),
      Inserir: montarRoles('PDV_MOVIMENTO', Acao.INSERIR),
      Deletar: montarRoles('PDV_MOVIMENTO', Acao.DELETAR),
    },
    Os: {
      Consultar: montarRoles('OS_ABERTURA', Acao.CONSULTAR),
      Atualizar: montarRoles('OS_ABERTURA', Acao.ATUALIZAR),
      Inserir: montarRoles('OS_ABERTURA', Acao.INSERIR),
      Deletar: montarRoles('OS_ABERTURA', Acao.DELETAR),
    },
    Nfe: {
      Consultar: montarRoles('NFE', Acao.CONSULTAR),
      Atualizar: montarRoles('NFE', Acao.ATUALIZAR),
      Inserir: montarRoles('NFE', Acao.INSERIR),
      Deletar: montarRoles('NFE', Acao.DELETAR),
    },
    RomaneioEntrega: {
      Consultar: montarRoles('ROMANEIO_ENTREGA', Acao.CONSULTAR),
      Atualizar: montarRoles('ROMANEIO_ENTREGA', Acao.ATUALIZAR),
      Inserir: montarRoles('ROMANEIO_ENTREGA', Acao.INSERIR),
      Deletar: montarRoles('ROMANEIO_ENTREGA', Acao.DELETAR),
    },
    Mdfe: {
      Consultar: montarRoles('MDFE', Acao.CONSULTAR),
      Atualizar: montarRoles('MDFE', Acao.ATUALIZAR),
      Inserir: montarRoles('MDFE', Acao.INSERIR),
      Deletar: montarRoles('MDFE', Acao.DELETAR),
    },
  },
  Contador: {
    Consultar: montarRoles('CONTADOR', Acao.CONSULTAR),
    Atualizar: montarRoles('CONTADOR', Acao.ATUALIZAR),
    Inserir: montarRoles('CONTADOR', Acao.INSERIR),
    Deletar: montarRoles('CONTADOR', Acao.DELETAR),
  },
  Suprimentos: {
    Entrada: {
      Consultar: montarRoles('NFE_ENTRADA', Acao.CONSULTAR),
      Atualizar: montarRoles('NFE_ENTRADA', Acao.ATUALIZAR),
      Inserir: montarRoles('NFE_ENTRADA', Acao.INSERIR),
      Deletar: montarRoles('NFE_ENTRADA', Acao.DELETAR),
    },
    EstoqueReajuste: {
      Consultar: montarRoles('ESTOQUE_REAJUSTE', Acao.CONSULTAR),
      Atualizar: montarRoles('ESTOQUE_REAJUSTE', Acao.ATUALIZAR),
      Inserir: montarRoles('ESTOQUE_REAJUSTE', Acao.INSERIR),
      Deletar: montarRoles('ESTOQUE_REAJUSTE', Acao.DELETAR),
    },
  },
};
